import { t } from '../../../utilities/translator'
import { WithTooltip } from '../../../components/tooltip/WithTooltip';
import abTesting from '../../../services/abTesting';
import AgentCommissionLabel from './AgentCommissionLabel';
import { getDisplayPrice } from '../../../utilities/priceHelper';
import classNames from 'classnames';
import ProposalDealFooter from '../ProposalDealFooter';

type Props = {
  offer: object,
  stickers: object,
  type?: string,
}

const DealFooter = ({
  offer,
  stickers,
  type,
}: Props) => {

  const getCapacity = () => {
    const {
      adult,
      child,
      childAges,
    } = offer?.capacity_from_filter;
    let kids = child;
    const babies =
      childAges.filter((kid) => kid < 2).length || 0;
    kids = kids - babies;

    return { adult, kids, babies };
  };

  const getOfferPrice = () => {
    const {
      price,
    } = offer;
    const { adult, kids } = getCapacity();

    return getDisplayPrice(Math.ceil(price / (adult + kids)));
  };

  const renderCrossoutPrice = () => {
    if (abTesting.crossoutPriceV2) {
      return (
        <div className="deal-price-cheaper flex gap-1 items-center me-auto font-medium text-error-dark">
          <span className="text-[14px]" dir="ltr">{`-${stickers.crossOut?.percent}%`}</span>
          <span className="text-[12px]">{t('dealItem.crossoutUsual')}</span>
          <WithTooltip text={`<div class="price-tooltip"><b>${t('dealItem.understandingPrice')}</b><span>${t('dealItem.understandingPriceText', { percent: stickers.crossOut?.percent })}</span></div>`}>
            <span className="deal-price-info"><i className="ri-information-line" /></span>
          </WithTooltip>
        </div>
      )
    }

    /* return (
      <div className="deal-price-cheaper flex gap-1 items-center">
        <WithTooltip text={`<div class="price-tooltip"><b>${t('dealItem.understandingPrice')}</b><span>${t('dealItem.understandingPriceText', { percent: stickers.crossOut?.percent })}</span></div>`}>
          <span className="deal-price-info"><i className="ri-information-line" /></span>
        </WithTooltip>
        <span className="deal-old-price">{getCrossoutPrice()}</span>
        <span className="deal-price-percent">{`-${stickers.crossOut?.percent}%`}</span>
      </div>
    ) */

    return '';
  };

  const offerPriceClasses = classNames('flex flex-col gap-1 items-end js-offer-price', {
    'w-full': window.dataGlobalSettings.siteType === 3,
  });

  if (type === 'proposals-list') {
    return <ProposalDealFooter offer={offer} stickers={stickers} type={type} offerPrice={getOfferPrice()} crossoutPrice={renderCrossoutPrice()} />
  }

  return (
    <div className="deal-footer flex justify-end gap-2 p-4">
      {!!(stickers?.crossOut?.percent && stickers?.crossOut?.percent > 3) && window.dataGlobalSettings.siteType !== 3 && renderCrossoutPrice()}

      <div className={offerPriceClasses} data-total-price={offer?.price}>
        <div className="flex gap-2 items-center w-full justify-between">
          {window.dataGlobalSettings.siteType === 3 && <AgentCommissionLabel />}
          <span className="text-xl font-bold leading-none ms-auto">{getOfferPrice()}</span>
        </div>
        <span className="text-[10px] !font-medium leading-none">{t('dealItem.per_person')}</span>
      </div>
    </div>
  )
}

export default DealFooter
